var React = require('react');

function RightArrowWhiteInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 7H15","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10 1.5L15 7L10 12.5","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

RightArrowWhiteInline.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none"};

module.exports = RightArrowWhiteInline;

RightArrowWhiteInline.default = RightArrowWhiteInline;
